import app from '../../scripts/app';
import classTypesDict from '../../scripts/enums/commercial-class-type';
import template from './object-preview.jade';

app.directive('cianAfObjectPreview', () => {
  return {
    template,
    scope: {},
    bindToController: {
      view: '@',
      heading: '@',
      address: '@',
      photo: '@',
      developer: '@',
      buildingMaterial: '@',
      buildingClassType: '@',
      quarter: '@',
      year: '@',
      totalArea: '@',
      floors: '@',
      passengerLifts: '@',
      cargoLifts: '@',
      undergrounds: '=',
    },
    transclude: {
      topRightButton: '?topRightButton',
    },
    controller: [
      'addFormService',
      'categoryService',
      'deviceService',
      'addressService',
      function (addFormService, categoryService, deviceService, addressService) {
        this.getLocationId = () => addressService.locationId;
        this.isMobile = deviceService.isMobile;
        this.view = this.view || 'normal';

        this.cssClass = {
          'object-preview_typeahead': this.view === 'typeahead',
          'object-preview_coworking': this.view === 'coworking',
          'object-preview_coworking-single': this.view === 'coworking-single',
          'object-preview_mobile': this.isMobile,
        };

        const classTypeItem = classTypesDict.find(item => item.value === this.buildingClassType);
        this.buildingClass = classTypeItem ? classTypeItem.text : '';

        this.pluralizeMins = {
          one: '{} минута',
          few: '{} минуты',
          many: '{} минут',
        };

        this.pluralizeFloors = {
          one: '{} этаж',
          few: '{} этажа',
          many: '{} этажей',
          other: '{} этажей',
        };
        this.isNumber = number => !isNaN(number);

        // Не все из этих объектов сворачиваются в короткую форму, но если они в будущем будут в нее сворачиваться, все будет уже учтено
        const residentialObjectsWithLiftField = [
          'newbuildingFlat', // Новостройка
          'flat', // Квартира
          'flatShare', // Доля в квартире
          'room', // Комната
          'bed', // Койко-место
        ];

        // Видимость лифтов в зависимости от категории
        // Если это не typeahead
        if (this.view === 'normal') {
          const { objectType, propertyType } = categoryService.getInfoByCategory(addFormService.ad.category);
          this.liftIsVisible = propertyType === 'residential' && residentialObjectsWithLiftField.includes(objectType);
        }
      },
    ],
    controllerAs: 'objectPreviewCtrl',
  };
});
